import React from 'react';
import { motion } from 'framer-motion';
import {
    ListTodo, BookOpen, Briefcase, Mail, Headphones, Utensils,
    Coffee, Droplets, Dumbbell, ShoppingCart, Users, Train,
    Check
} from 'lucide-react';
import { useTranslation } from '../../../providers/TranslationProvider';

const Step3Flow = ({ data, onUpdate, isDarkMode }) => {
    const { t } = useTranslation();
    const selectedFlow = data.flowHabits || [];

    const flowOptions = [
        { id: 'plan', label: t('onboarding.flow.plan'), icon: ListTodo },
        { id: 'study', label: t('onboarding.flow.study'), icon: BookOpen },
        { id: 'work', label: t('onboarding.flow.work'), icon: Briefcase },
        { id: 'emails', label: t('onboarding.flow.emails'), icon: Mail },
        { id: 'deepwork', label: t('onboarding.flow.deepwork'), icon: Headphones },
        { id: 'lunch', label: t('onboarding.flow.lunch'), icon: Utensils },
        { id: 'coffee', label: t('onboarding.flow.coffee'), icon: Coffee },
        { id: 'water', label: t('onboarding.flow.water'), icon: Droplets },
        { id: 'workout', label: t('onboarding.flow.workout'), icon: Dumbbell },
        { id: 'grocery', label: t('onboarding.flow.grocery'), icon: ShoppingCart },
        { id: 'socialize', label: t('onboarding.flow.socialize'), icon: Users },
        { id: 'commute', label: t('onboarding.flow.commute'), icon: Train },
    ];

    const toggleFlow = (id) => {
        if (selectedFlow.includes(id)) {
            onUpdate({ flowHabits: selectedFlow.filter(item => item !== id) });
        } else {
            onUpdate({ flowHabits: [...selectedFlow, id] });
        }
    };

    return (
        <div className="w-full">
            <motion.div
                className="grid grid-cols-3 gap-2"
                initial="hidden"
                animate="visible"
                variants={{
                    visible: { transition: { staggerChildren: 0.03 } }
                }}
            >
                {flowOptions.map((option) => {
                    const isSelected = selectedFlow.includes(option.id);
                    const Icon = option.icon;
                    return (
                        <motion.button
                            key={option.id}
                            variants={{
                                hidden: { opacity: 0, scale: 0.9 },
                                visible: { opacity: 1, scale: 1 }
                            }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => toggleFlow(option.id)}
                            className={`p-2.5 rounded-xl border flex flex-col items-center gap-1.5 transition-all duration-200 relative overflow-hidden backdrop-blur-md min-h-[80px] justify-center ${isSelected
                                ? 'border-blue-500 bg-blue-500/10'
                                : isDarkMode
                                    ? 'border-white/5 bg-white/5 hover:border-white/20'
                                    : 'border-slate-200 bg-white/50 hover:bg-slate-50'
                                }`}
                        >
                            <div className={`p-1.5 rounded-lg shrink-0 transition-colors duration-200 ${isSelected
                                ? 'bg-blue-500 text-white'
                                : isDarkMode ? 'bg-white/5 text-slate-400' : 'bg-slate-100 text-slate-500'
                                }`}>
                                <Icon size={16} />
                            </div>
                            <span className={`text-xs font-medium truncate w-full ${isSelected
                                ? 'text-blue-400'
                                : isDarkMode ? 'text-slate-300' : 'text-slate-700'
                                }`}>
                                {option.label}
                            </span>

                            {isSelected && (
                                <div className="absolute top-1 right-1 text-blue-500">
                                    <Check size={10} className="fill-current" />
                                </div>
                            )}
                        </motion.button>
                    );
                })}
            </motion.div>
        </div>
    );
};

export default Step3Flow;
